<template>
    <main className="container justify-center min-h-screen mx-auto px-8 py-8">
        <slot />
    </main>
</template>

<script>
export default {
    name: "LayoutMaster"
}
</script>

<style lang="scss" scoped></style>